import { Pagination } from "services/search";
import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { Inquiry, InquiryRow, InquirySource } from "./types";
import { transformInquiry, transformInquiryRow } from "./transformations";

export const getInquiriesAPI = async (
  pagination: Pagination,
  search?: string | null,
  inquirySourceId?: string | null,
  status?: string | null
): Promise<DataWithPagination<InquiryRow>> => {
  let path = `/v1/sales/inquiries?search=`;
  if (search) path += `${search}`;
  if (inquirySourceId) path += `&inquirySourceId=${inquirySourceId}`;
  if (status) path += `&status=${status}`;

  return await paginatedApiCall(path, pagination, transformInquiryRow);
};

export const getInquiryAPI = async (id: string): Promise<Inquiry> => {
  const response = await createApiCall(
    { path: `/v1/sales/inquiries/${id}`, method: "GET" },
    { getMessage: { error: (error: any) => `${error.response.data.message}` } }
  )();
  return transformInquiry(response.data);
};

export const createInquiryAPI = async (body: any): Promise<Inquiry> => {
  const response = await createApiCall(
    { path: "/v1/sales/inquiries", method: "POST", body },
    { getMessage: { error: (error: any) => `${error.response.data.message}` } }
  )();
  return transformInquiry(response.data);
};

export const updateInquiryAPI = async (id: string, body: any): Promise<Inquiry> => {
  const response = await createApiCall(
    { path: `/v1/sales/inquiries/${id}`, method: "PUT", body },
    { getMessage: { error: (error: any) => `${error.response.data.message}` } }
  )();
  return transformInquiry(response.data);
};

export const deleteInquiryAPI = async (id: string): Promise<boolean> => {
  const response = await createApiCall(
    { path: `/v1/sales/inquiries/${id}`, method: "DELETE" },
    { getMessage: { error: (error: any) => `${error.response.data.message}` } }
  )();
  return response.data?.deleted;
};

export const getInquirySourcesAPI = async (): Promise<InquirySource[]> => {
  const response = await createApiCall(
    { path: "/v1/sales/inquiry-sources", method: "GET" },
    { getMessage: { error: (error: any) => `${error.response.data.message}` } }
  )();
  return response.data;
};
